module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x1-59d36952eb28d76d126e242f731de7ab.jpg";